import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { display, height } from 'styled-system';

import { Flex } from '../Flex';

const UnstyledDrawerContent = styled(Flex)<any>`
  ${display};
  ${height};
`;

const DrawerContent = (props: ComponentProps<typeof UnstyledDrawerContent>) => (
  <UnstyledDrawerContent
    data-testid="drawer-content"
    flexDirection="column"
    height="100%"
    {...props}
  />
);

export default DrawerContent;
